/* eslint-disable react/sort-comp */
import * as React from 'react';
import styled from 'styled-components';
import classnames from 'classnames';
import * as Keycode from 'keycode-js';
import { RadioIconRC } from '../Icons';
import TranslationUtils from '../../utils/TranslationUtils';

export const StyledRadioIconWrapper = styled.div`
  line-height: 0;
`;

export const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const IconWrapper = styled.div`
  flex-grow: 0;
  margin-right: 8px;
`;

export const LabelWrapper = styled.div`
  flex-grow: 1;
  align-self: center;
`;

interface IRadioBoxProps {
  className?: string;
  selected?: boolean;
  disabled?: boolean;
  tabIndex?: number;
  children?: React.ReactNodeArray | React.ReactNode;
  dataTestId?: string;
  label?: string;
  accessibleLabel?: string;
  onSelect?(e?: React.KeyboardEvent | React.MouseEvent): void;
}

class RadioBox extends React.Component<IRadioBoxProps> {
  public static defaultProps = {
    tabIndex: 0,
  };

  private get accessibleLabel(): string {
    const { label, accessibleLabel } = this.props;

    if (
      !(
        label &&
        TranslationUtils.isTranslationItemValid(label) &&
        accessibleLabel
      )
    ) {
      return accessibleLabel;
    }

    return `option-${label.replace(/\s/g, '-')}`;
  }

  public render(): JSX.Element {
    const { className, selected, children, disabled, tabIndex, dataTestId } =
      this.props;

    const componentClassName = classnames(
      'acac-select-address-radio',
      className,
      {
        disabled,
      },
    );

    const iconClassName = classnames('acac-select-address-radio-icon', {
      disabled,
    });

    return (
      <ComponentWrapper className={componentClassName}>
        <IconWrapper>
          <StyledRadioIconWrapper
            onClick={this.onClick}
            onKeyPress={this.onKeyPress}
            tabIndex={tabIndex}
            role="radio"
            aria-checked={selected}
            data-test-id={dataTestId}
            aria-labelledby={this.accessibleLabel}
          >
            <RadioIconRC className={iconClassName} isChecked={selected} />
          </StyledRadioIconWrapper>
        </IconWrapper>
        <LabelWrapper id={this.accessibleLabel}>
          {children || null}
        </LabelWrapper>
      </ComponentWrapper>
    );
  }

  private onClick = (e: React.KeyboardEvent | React.MouseEvent): void => {
    const { disabled, onSelect } = this.props;

    if (!disabled && onSelect) {
      onSelect(e);
    }
  };

  private onKeyPress: React.KeyboardEventHandler<HTMLDivElement> = (
    e: React.KeyboardEvent,
  ) => {
    const code = e.charCode;
    const acceptedKeys = [
      Keycode.KEY_RETURN,
      Keycode.KEY_ENTER,
      Keycode.KEY_SPACE,
    ];
    if (acceptedKeys.indexOf(code) >= 0) {
      this.onClick(e);
      e.preventDefault();
      e.stopPropagation();
    }
  };
}

export default RadioBox;
